import React from "react";
import CustomComponentWrapper from "../../../utils/CustomComponentWrapper/CustomComponentWrapper";
import { CssClassName } from "../../../utils/generateCssClassName/types";
import { isKiosk } from "../../../utils/isKiosk";
import LanguageSelector from "../../elements/LanguageSelector/LanguageSelector";
import ProvinceSelector from "../../elements/ProvinceSelector/ProvinceSelector";
import { InnerContainer, SkipContainer, SkipNavLink } from "./styles";

interface Props {
  preferredLocale?: string;
  selectLocaleToSave: () => void;
  preferredProvince?: string;
  selectProvinceToSave: () => void;
  skipToContentFocus: () => void;
}

const LanguagePicker = ({
  skipToContentFocus,
  preferredLocale,
  selectLocaleToSave,
  preferredProvince,
  selectProvinceToSave,
}: Props) => {
  const kiosk = isKiosk();
  return (
    <InnerContainer className="locale">
      <SkipContainer>
        <SkipNavLink
          onClick={skipToContentFocus}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              skipToContentFocus();
            }
          }}
          tabIndex={0}
        >
          {preferredLocale === 'en'
            ? 'Skip to content'
            : 'Aller au contenu'}
        </SkipNavLink>
      </SkipContainer>
      <LanguageSelector
        preferredLocale={preferredLocale}
        selectLocaleToSave={selectLocaleToSave}
      />
  
      <CustomComponentWrapper
        id={CssClassName.KIOSK}
        hideFlag={kiosk}
      >
        |
        <ProvinceSelector
          preferredProvince={preferredProvince}
          preferredLocale={preferredLocale}
          selectProvinceToSave={selectProvinceToSave}
          idToAppend="header"
        />
      </CustomComponentWrapper>
    </InnerContainer>
  );
};

export default LanguagePicker;
